<template>
    <div>
        <e-search
                class="container"
                :count="10"
                :data="filterInfo.data"
                :field-list="filterInfo.fieldList"
                :list-type-info="listTypeInfo"
                :width="filterInfo.width"
                @handleFilter="handleFilter"
                @handleReset="handleReset"
        ></e-search>

        <div class="container">
            <TableList
                    :table-data="tableData"
                    :table-label="tableLabel">
                <template v-slot:showIndex="slot">
                    <span>{{ (queryData.pageNum - 1) * queryData.pageSize + slot.scope.$index + 1 }}</span>
                </template>
                <template v-slot:status="slot">
                    <el-tag v-if="slot.scope.row.status === 101"> 待报名 </el-tag>
                    <el-tag v-else-if="slot.scope.row.status === 102"> 待审核 </el-tag>
                    <el-tag v-else-if="slot.scope.row.status === 103" type="danger">审核驳回</el-tag>
                    <el-tag v-else-if="slot.scope.row.status === 104" type="success">审核通过</el-tag>
                </template>
                <template v-slot:operate="slot">
                    <el-button type="text" v-if="slot.scope.row.status === 101" @click="enroll(slot.scope.row.id)">报名</el-button>
                    <el-button type="text" v-if="slot.scope.row.status === 104" @click="viewActivity(slot.scope.row.id)" >查看活动</el-button>
                    <el-button type="text" v-if="slot.scope.row.status === 103" @click="viewReason(slot.scope.row.id)"  >原因查询</el-button>
                    <el-button type="text" v-if="slot.scope.row.status === 102 || slot.scope.row.status === 103"
                               @click="enroll(slot.scope.row.id)">编辑并提交
                    </el-button>

                </template>
            </TableList>

            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="queryData.pageNum"
                        :page-size="queryData.pageSize"
                        :total="queryData.pageTotal"
                        prev-text="上一页"
                        next-text="下一页"
                ></el-pagination>
            </div>
        </div>
        <reason-dialog :visible="visible" :id="handleId" v-if="visible" @closeDialog="closeDialog"/>

    </div>
</template>

<script>
    import TableList from '../../components/common/e-table-list';
    import eSearch from "../../components/common/e-search";
    import api from "../../api/cms/index";
    import ReasonDialog from "./common/reasonDialog";
    import {epecMallUrl}  from '../../api/config'
    export default {
         components: {
            TableList,
            eSearch,
            ReasonDialog
        },
        data() {
            return {
                handleId:0,
                visible:false,//驳回原因弹框
                queryData: {
                    activityName: null,
                    status: null,
                    pageNum: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                tableData: [],
                tableLabel: [
                    {label: "序号", slot: "showIndex", align: "center", width: '80'},
                    {label: "活动名称", param: "activityName", align: "center", width: "200"},
                    {
                        label: "活动起止时间", param: "", width: "290", align: "center", render: (row) => {
                            return row.startTime + '~' + row.endTime
                        }
                    },
                    {
                        label: "活动报名状态", param: "status", align: "center", slot:'status'
                    },
                    {label: "咨询电话", param: "telephone", align: "center"},
                    {label: "操作", slot: 'operate', align: "center"},
                ],
                listTypeInfo: {
                    statusList: [
                        {id: 101, name: '待报名'},
                        {id: 102, name: '待审核'},
                        {id: 103, name: '审核通过'},
                        {id: 104, name: '审核驳回'},
                    ],
                },
                filterInfo: {
                    data: {
                        activityName: null,
                        status: null,
                    },
                    fieldList: [
                        {label: "活动名称", type: "input", value: "activityName"},
                        {label: "活动报名状态", type: "select", value: "status", list: 'statusList'},
                    ],
                    /**配置项 */
                    btnStyle: [
                        {
                            icon: "el-icon-search",
                            text: "过滤",
                            type: "primary"
                        },
                        {
                            icon: "el-icon-refresh",
                            text: "重置"
                        }
                    ]
                },
            }
        },
        methods: {
            closeDialog(){
                this.visible = false;
            },
            viewActivity(id){
                console.log(id)
                window.open(`${epecMallUrl}/themeActivities?id=${id}`, '_blank')
            },
            viewReason(id){
                this.handleId = id;
                this.visible = true;
            },
            //报名
            enroll(id) {
                this.$router.push({path: '/eventRegistration', query: {id: id}})
            },
            handleReset() {
                this.queryData = {
                    activityName: null,
                    status: null,
                    pageNum: 1,
                    pageSize: 10,
                    pageTotal: 0,
                }
                this.queryCompanySignMessage();
            },
            handleFilter(val) {
                this.queryData.activityName = val.activityName;
                this.queryData.status = val.status;
                this.queryData.pageNum = 1;
                this.queryCompanySignMessage();
            },
            handleSizeChange(val) {
                this.queryData.pageNum = 1;
                this.queryData.pageSize = val;
                this.queryCompanySignMessage();
            },
            handleCurrentChange(val) {
                this.queryData.pageNum = val;
                this.queryCompanySignMessage();
            },
            async queryCompanySignMessage() {
                let res = await api.queryCompanySignMessage(this.queryData)
                if (res.code === '200') {
                    this.tableData = res.data.records || [];
                    this.queryData.pageTotal = res.data.total || 0;
                }

            },
        },
        mounted() {
            this.queryCompanySignMessage();
        }

    }
</script>

<style scoped lang="scss">

</style>